import { render, staticRenderFns } from "./Antragsbuch.vue?vue&type=template&id=678d7ac2&scoped=true"
import script from "./Antragsbuch.vue?vue&type=script&lang=ts"
export * from "./Antragsbuch.vue?vue&type=script&lang=ts"
import style0 from "./Antragsbuch.vue?vue&type=style&index=0&id=678d7ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d7ac2",
  null
  
)

export default component.exports